import React, { useEffect } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const ProductDetailsIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const product = location.state?.product;

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  if (!product) {
    // If user visits directly without state, redirect or show message
    navigate("/products");
    return null;
  }

  return (
    <div className="min-h-screen bg-blue_bg-100 p-6 md:p-12 flex flex-col md:flex-row gap-12 items-center justify-center">
      {/* Left Section - Product Images */}
      <div className="flex flex-col items-center space-y-6 pt-20">
        <img
          src={`/assets/${product.image}`}
          alt={product.category}
          className="rounded-xl"
        />
      </div>

      {/* Right Section - Product Info */}
      <div className="max-w-lg space-y-6">
        <div>
          <h1 className="text-3xl font-semibold text-gray-800">
            {product.category}
          </h1>
          <p className="text-sm text-green-500 mt-1">In stock</p>
        </div>

        <p className="text-gray-600 leading-relaxed">{product.description}</p>

        {/* Button */}
        <div className="flex items-center space-x-4 mt-4">
          <NavLink to="/contact" className="flex items-center gap-2 bg-primary-200 shadow-sharp-blue text-white px-6 py-3 transition">
            Send Inquiry
          </NavLink>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailsIndex;
